var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("contact-navbar", {
        staticClass: "mb-1",
        attrs: { search: "" },
        on: {
          search: function ($event) {
            return _vm.onSearchChanged($event)
          },
          "delete-search": _vm.onSearchDelete,
        },
      }),
      _vm._v(" "),
      _vm.numContacts > 0
        ? _c("div", [
            _c("small", { staticClass: "text-muted me-1" }, [
              _vm._v(_vm._s(_vm.numContacts) + " Treffer"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "d-flex flex-wrap align-items-stretch mt-1",
                class: {
                  "justify-content-between": _vm.numContacts > 2,
                  "justify-content-start": _vm.numContacts < 3,
                },
              },
              _vm._l(_vm.filteredContacts, function (contact) {
                return _c(
                  "router-link",
                  {
                    key: contact.id,
                    staticClass: "text-center text-deco-none",
                    attrs: { to: _vm.contactUrl(contact) },
                  },
                  [_c("contact-card", { attrs: { contact: contact } })],
                  1
                )
              }),
              1
            ),
          ])
        : _c("div", [
            _c("div", { staticClass: "text-center mt-5" }, [
              _vm._v("-- keine Treffer --"),
            ]),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }